const validation = {
  language: { required: 'Ce champ est requis' },
};

export default validation;
